import { ICloseDailyDairyPayload, ICloseDailyDairyServiceResponse, IGetDailyDairyServiceResponse, ISubmitDailyDairySlotPayload } from "../../../features/dailyDairyReport/types";
import ApiService from "../../ApiService";

enum DailyDairyEndpoints {
  GET_DAILY_DAIRY_SLOTS = "/daily-dairy/slots",
  DAILY_DAIRY_SLOT_SUBMIT = "/daily-dairy/submit-task",
  DAILY_DAIRY_CLOSE = "/daily-dairy/close",
}

class DailyDairyService extends ApiService {
  async getDailyDairySlots(
    userId?: number,
    date?: string
  ): Promise<IGetDailyDairyServiceResponse> {
    return this.post<IGetDailyDairyServiceResponse>(
      DailyDairyEndpoints.GET_DAILY_DAIRY_SLOTS,
      {
        user_id: userId,
        date,
      }
    );
  }
  async submitDailyDairySlot(
    params: ISubmitDailyDairySlotPayload
  ): Promise<{ status: boolean; message: string }> {
    return this.post<{ status: boolean; message: string }>(
      DailyDairyEndpoints.DAILY_DAIRY_SLOT_SUBMIT,
      params
    );
  }
  async closeSubmitDairy(
    params: ICloseDailyDairyPayload
  ): Promise<ICloseDailyDairyServiceResponse> {
    return this.post<ICloseDailyDairyServiceResponse>(
      DailyDairyEndpoints.DAILY_DAIRY_CLOSE,
      params
    );
  }
}

export const dailyDairyService = new DailyDairyService();
